import Swiper from 'swiper/bundle';

(function () {
  const initPromoSlider = () => {
    const devices = ["desktop", "mobile"];

    devices.forEach((device) => {
      const swiperSelector = `#promo-bar.${device} .promo-bar__swiper`;
      const container = document.querySelector(swiperSelector);

      if (container) {
        setupSwiper(container, device, swiperSelector);
      }
    });
  };

  const setupSwiper = (container, device, selector) => {
    const slides = container.querySelectorAll(".swiper-slide");
    const promoBar = container.closest("#promo-bar");

    // fall back to the first slide's background color if not set
    const firstSlide = slides[0];
    const defaultBg = firstSlide?.style.backgroundColor;

    const autoScrollEnabled =
      container.getAttribute("data-auto-scroll") === "true";
    const scrollSpeed =
      parseInt(container.getAttribute("data-auto-scroll-speed"), 10) * 1000;

    const config = {
      loop: slides.length > 1,
      slidesPerView: 1,
      centerSlides: true,
      centerSlidesBounds: true,
      allowTouchMove: device === "mobile",
      autoplay:
        autoScrollEnabled && slides.length > 1
          ? {
              delay: scrollSpeed,
              disableOnInteraction: false,
            }
          : false,
      on: {
        init(swiper) {
          if (defaultBg) {
            promoBar.style.backgroundColor = defaultBg;
          }
        },
        slideChange(swiper) {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const bg = activeSlide?.style.backgroundColor || defaultBg;

          if (bg) {
            promoBar.style.backgroundColor = bg;
          }
        },
      },
    };

    let swiper = new Swiper(container, config);

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", (evt) => {
        if (evt.detail.sectionId === "promo-bar") {
          const newContainer = evt.target.querySelector(selector);
          if (newContainer) {
            swiper = new Swiper(newContainer, config);
          }
        }
      });

      document.addEventListener("shopify:section:unload", (evt) => {
        if (evt.detail.sectionId === "promo-bar") {
          swiper.destroy();
        }
      });

      document.addEventListener("shopify:block:select", (evt) => {
        const block = evt.target;
        const index = Array.from(block.parentNode.children).indexOf(block);

        if (evt.detail.load) {
          swiper = new Swiper(selector, { initialSlide: index, ...config });
        } else {
          swiper.slideTo(index);
        }
      });
    }
  };

  initPromoSlider();
})();
